module.exports = __webpack_public_path__ + "img/close.9e5eb6cd.svg";